import { render, staticRenderFns } from "./StartLearning.vue?vue&type=template&id=4f696c3e&scoped=true&"
import script from "./StartLearning.vue?vue&type=script&lang=js&"
export * from "./StartLearning.vue?vue&type=script&lang=js&"
import style0 from "./StartLearning.vue?vue&type=style&index=0&id=4f696c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f696c3e",
  null
  
)

export default component.exports